'use client';

import dynamic from 'next/dynamic';
import { useEffect, useMemo, useState } from 'react';

const NightSkyParticles = dynamic(
  () => import('../../(reporter)/reporter/components/NightSkyParticles'),
  { ssr: false, loading: () => null },
);

function useInViewOnce(rootMargin = '150px') {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = document.getElementById('weathercard-particles-anchor');
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { root: null, rootMargin, threshold: 0.01 },
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, [rootMargin]);

  return inView;
}

function prefersReducedMotion() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
}

export default function NightSkyParticlesClient() {
  const inView = useInViewOnce('200px');
  const [ok, setOk] = useState(false);

  useEffect(() => {
    if (!inView) return;
    if (prefersReducedMotion()) return;

    // небольшой defer, чтобы не мешать TTI
    const t = window.setTimeout(() => setOk(true), 250);
    return () => window.clearTimeout(t);
  }, [inView]);

  if (!inView || !ok) return null;

  return <NightSkyParticles />;
}
